import React, { useState } from "react";

export default function KapcsolatOldal() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setError("Minden mező kitöltése kötelező!");
      return;
    }

    // Itt történne az email küldés
    console.log("Kapcsolatfelvételi űrlap elküldve:", form);
    setSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setSubmitted(false);
      setForm({ name: "", email: "", message: "" });
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-[#161616] backdrop-blur-xl rounded-2xl shadow-2xl border border-white/[0.08] overflow-hidden">
          <div className="p-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-white mb-4">📄 Kapcsolat</h1>
              <div className="w-24 h-1 bg-gradient-to-r from-[#e31937] to-[#b40000] mx-auto rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Kapcsolati információk */}
              <div className="space-y-6">
                <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                  <h2 className="text-xl font-bold text-white mb-4">HOPPX LTD</h2>
                  <div className="space-y-3 text-gray-300">
                    <div className="flex items-start space-x-3">
                      <div className="text-[#e31937] text-lg">📍</div>
                      <div>
                        <p className="font-semibold text-white">Székhely:</p>
                        <p>20-22 Wenlock Road, London N1 7GU, Egyesült Királyság</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start space-x-3">
                      <div className="text-[#e31937] text-lg">📧</div>
                      <div>
                        <p className="font-semibold text-white">E-mail:</p>
                        <a href="mailto:hoppxplatform@gmail.com" className="text-[#e31937] hover:text-[#b40000] transition-colors">
                          hoppxplatform@gmail.com
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="text-[#e31937] text-lg">👤</div>
                      <div>
                        <p className="font-semibold text-white">Képviselő:</p>
                        <p>Kollár István Antal</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-6">
                  <div className="flex items-start space-x-3">
                    <div className="text-blue-400 text-xl">ℹ️</div>
                    <div>
                      <h3 className="text-blue-300 font-semibold mb-2">Válaszidő</h3>
                      <p className="text-blue-200 text-sm">
                        A megkeresésekre <span className="font-semibold">3 munkanapon belül</span> válaszolunk.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Kapcsolatfelvételi űrlap */}
              <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                <h2 className="text-xl font-bold text-white mb-6">Kapcsolatfelvételi űrlap</h2>
                
                {submitted ? (
                  <div className="text-center py-8">
                    <div className="text-green-400 text-4xl mb-4">✅</div>
                    <h3 className="text-green-300 font-semibold text-lg mb-2">Köszönjük!</h3>
                    <p className="text-green-200">Üzenetét sikeresen elküldtük. Hamarosan felvesszük Önnel a kapcsolatot.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                      <label htmlFor="name" className="block text-white font-medium mb-2">
                        Név <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 bg-white/10 border border-white/[0.08] rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e31937] focus:border-transparent"
                        placeholder="Teljes név"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-white font-medium mb-2">
                        E-mail cím <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 bg-white/10 border border-white/[0.08] rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e31937] focus:border-transparent"
                        placeholder="email@example.com"
                      />
                    </div>

                    <div>
                      <label htmlFor="message" className="block text-white font-medium mb-2">
                        Üzenet <span className="text-red-400">*</span>
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        required
                        rows={5}
                        className="w-full px-4 py-3 bg-white/10 border border-white/[0.08] rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e31937] focus:border-transparent resize-none"
                        placeholder="Írja meg üzenetét..."
                      />
                    </div>

                    {error && (
                      <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3">
                        <p className="text-red-300 text-sm">{error}</p>
                      </div>
                    )}

                    <button
                      type="submit"
                      className="w-full bg-gradient-to-r from-[#e31937] to-[#b40000] hover:from-[#b40000] hover:to-[#8b0000] text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
                    >
                      Üzenet küldése
                    </button>
                  </form>
                )}
              </div>
            </div>

            <div className="mt-8 text-center">
              <a 
                href="/"
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-semibold rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Vissza a főoldalra
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
